
export default {
    name: 'SkipHire',
    data() {
        return {
            reviews: [],
        };
    },
    async fetch() {
        await this.$store.dispatch('services/get');
        const reviews = await this.$axios.$get(this.$config.endpoints.testimonial, {
            params: {
                per_page: 2,
                rating: 5,
                service_id: 2,
            },
        });

        this.reviews = reviews.testimonials?.data;
    },
    head() {
        return {
            meta: [
                { hid: 'og:title', property: 'og:title', content: `${this.$t('metadata.services-skip-hire.title')} - ClearWaste` },
                { hid: 'og:description', property: 'og:description', content: this.$t('metadata.services-skip-hire.description') },
                { hid: 'og:image', property: 'og:image', content: `${this.$config.cdn_domain}/images/services/skip.png` },
                { hid: 'og:url', property: 'og:url', content: `${this.$config.domain}${this.$route.path}` },
            ],
        };
    },
    computed: {
        sections() {
            return [
                {
                    title: this.$t('services.skip_hire.size_title'),
                    text: this.$t('services.skip_hire.size_text'),
                    skips: true,
                },
                {
                    title: this.$t('services.customer_reviews.title'),
                    text: this.$t('services.customer_reviews.text'),
                    reviews: this.reviews,
                },
                {
                    title: this.$t('services.usp.1.title'),
                    text: this.$t('services.usp.1.text'),
                    link: {
                        url: 'customer-guarantee',
                        text: this.$t('titles.customer-guarantee'),
                    },
                },
                {
                    title: this.$t('services.skip_hire.skip_contents.title'),
                    text: this.$t('services.skip_hire.skip_contents.text'),
                    image: '/images/jobs/skip.svg',
                    imageAlt: 'Lorry carrying a skip.',
                },
                {
                    title: this.$t('services.usp.2.title'),
                    text: this.$t('services.usp.2.text'),
                    link: {
                        url: 'waste-removal',
                        query: { service: 2 },
                        text: this.$t('waste_removal.get_quotes_now'),
                    },
                },
                {
                    title: this.$t('services.skip_hire.permits.title'),
                    text: this.$t('services.skip_hire.permits.text'),
                    image: '/images/services/choice-of-skip-size',
                    imageAlt: 'Yellow skip filled with rubbish.',
                },
                {
                    title: this.$t('services.skip_hire.alternatives.title'),
                    text: this.$t('services.skip_hire.alternatives.text'),
                    image: '/images/jobs/van.svg',
                    imageAlt: 'Man next to a van.',
                    link: {
                        url: 'waste-removal',
                        text: this.$t('services.see_options'),
                    },
                },
            ];
        },
    },
};
